type Envs = "local" | "dev" | "test" | "demo" | "prod";

interface IEnvConfig {
    authUrl: string;
    valueApiUrl: string;
    crmApiUrl: string;
    clarityProjectId?: string;
}

const ENV_CONFIGS: Record<Envs, IEnvConfig> = {
    local: {
        authUrl: import.meta.env.VITE_AUTH_BASE,
        valueApiUrl: import.meta.env.VITE_API_BASE,
        crmApiUrl: import.meta.env.VITE_CRM_API_BASE,
    },
    dev: {
        authUrl: import.meta.env.VITE_AUTH_BASE || "https://auth.dev.qa.dbg.com",
        valueApiUrl: import.meta.env.VITE_API_BASE || "https://api.dev.qa.dbg.com/value",
        crmApiUrl: import.meta.env.VITE_CRM_API_BASE || "https://api.dev.qa.dbg.com/crm",
        clarityProjectId: "t55s1rulq6",
    },
    test: {
        authUrl: import.meta.env.VITE_AUTH_BASE || "https://auth.test.qa.dbg.com",
        valueApiUrl: import.meta.env.VITE_API_BASE || "https://api.test.qa.dbg.com/value",
        crmApiUrl: import.meta.env.VITE_CRM_API_BASE || "https://api.test.qa.dbg.com/crm",
    },
    demo: {
        authUrl: import.meta.env.VITE_AUTH_BASE || "https://auth.demo.dbg.com",
        valueApiUrl: import.meta.env.VITE_API_BASE || "https://api.demo.dbg.com/value",
        crmApiUrl: import.meta.env.VITE_CRM_API_BASE || "https://api.demo.dbg.com/crm",
        clarityProjectId: "t4vrgj5cpf",
    },
    prod: {
        authUrl: import.meta.env.VITE_AUTH_BASE || "https://auth.dbg.com",
        valueApiUrl: import.meta.env.VITE_API_BASE || "https://api.dbg.com/value",
        crmApiUrl: import.meta.env.VITE_CRM_API_BASE || "https://api.dbg.com/crm",
        clarityProjectId: "t56dmc50cn",
    },
};

// Function to determine the environment based on the hostname
export function getEnv(): Envs {
    const hostname = window.location.hostname;

    let env: Envs;
    if (hostname.includes("localhost")) {
        env = "local";
    } else if (hostname.includes("dev")) {
        env = "dev";
    } else if (hostname.includes("test")) {
        env = "test";
    } else if (hostname.includes("demo")) {
        env = "demo";
    } else {
        env = "prod";
    }

    return env;
}

function getConfig() {
    return ENV_CONFIGS[getEnv()];
}

export const config = {

    get authHost() {
        return getConfig().authUrl;
    },

    get valueApiHost() {
        return getConfig().valueApiUrl;
    },

    get crmApiHost() {
        return getConfig().crmApiUrl;
    },

    get clarityProjectId() {
        return getConfig().clarityProjectId;
    }
}
